<template>
<div >
    <div v-if="partie" style="margin-bottom: 20px;">
        <div v-if="partie.completeJoueurs" style="border: dashed black thin;border-radius:10px;margin: 10px;">
            <div class="title is-4">Equipe qualifiée</div>
        <div v-for="numero in partie.completeJoueurs" style="display:inline-block;">     
            <equipe-qualified :joueurs="tournoi.joueurs" :numero="numero"/>
        </div>
        </div>
    </div>
<div v-if="pools.length==0" class="noTeams">
    Aucune équipe pour le moment 
</div>

<div v-for="(pool, indexPool) in pools" :class="getClassPool()" v-if="pool && partie!=null" >
 <div class="titlePool" v-if="partie.type!='CADRAGE' && partie.type!='ELIMINATOIRE' ">   POULE {{indexPool+1}} </div>
 
<div v-for="equipe in pool.equipes" v-show="isSearch(equipe)" :class="getClassTeam(equipe)" v-if="equipe!=null"  >
  
        <div class="team">
           
            <equipe 
                :partie="partie"
                :equipe="equipe" 
                :joueurs="joueurs" 
                type="joueurs" 
                :changeFlagJoueur="changeFlagJoueur"
                @deleteJoueur="deleteJoueur"
                @changerJoueur="changerJoueur" 
                @changeEffect="changeEffect"
                @selectJoueur="selectJoueur"
                @saveScore="saveScore"
                 @openModalScore="openModalScore"
                :role="role" 
                :mode="tournoi.options.mode"
                :options="tournoi.options"
                :indexPartie = "indexPartie"
                :showError = "showError"
                :tournoi="tournoi"
            />
    </div>  
    <div class="vs" v-if="!isNaN(equipe.contre.J1.numero) && equipe.contre.J1.numero!=null" >
        <i class="fas fa-arrows-alt-h"></i>
        <br/><br/>
    </div>
    <div class="teamVS" v-if="!isNaN(equipe.contre.J1.numero)  && equipe.contre.J1.numero!=null" >
        <equipe 
            :partie="partie"
            :equipe="equipe" 
            :joueurs="joueurs" 
            type="contre"
            :changeFlagJoueur="changeFlagJoueur"
            @deleteJoueur="deleteJoueur"
            @changerJoueur="changerJoueur" 
            @changeEffect="changeEffect"
            @selectJoueur="selectJoueur"
            @saveScore="saveScore"
             @openModalScore="openModalScore"
            :role="role" 
            :mode="tournoi.options.mode"
            :options="tournoi.options"
            :indexPartie = "indexPartie"
            :showError = "showError"
             :tournoi="tournoi"
             v-if="equipe.contre.J1.numero!=null"
        />
    </div>
    <div class="finish" v-if="equipe!=null">
       
       <s-button 
            icon="lock-open" theme="is-small is-danger" 
            label="Déverouiler" @onclick="deverouiller(equipe)" :role = "role"
            :disabled="equipeIsLock(equipe)"
            v-show="showDeverouiller(equipe)"
             /> 
        <div  v-show="!showDeverouiller(equipe)">&nbsp;</div>            
            
    </div>
</div>
</div>
   
    <div class="footer">
        &nbsp;
    </div>
</div>
</template>
<style scoped>
.noTeams {
    font-size: 30px;
}
.titlePool {
    font-weight: bold;
    background-color: gray;
    color: white;
    border-radius: 20px;
} 
.equipeGG {
    border-radius: 20px;
    background-color: white;
    float: left;
    margin-left: 20px;
    margin-top: 10px;
    padding: 5px;
    width: 40px;
}
.arbitreTerrain {
    float: right;
    margin-right: 5px;
    height: 10px;
    
}
.header {
    margin-top: 10px;
    padding-left: 20px;
    text-align: left;
}
.state {
    border: thin black solid;
    padding: 5px;
    display: inline-block;
    border-radius: 10px;
    font-size: 12px;
}
.stwaiting {
    background-color: orange;
}

.stinprogress {
    background-color: greenyellow;
}
.stfinish {
    background-color: rgb(20, 20, 20);
    color: white;
}
.footer {
    height: 40px;
    background-color: white;
}
.teamQualifie {
     display: inline-block;
        height: 140px;
        background-color: rgb(39, 121, 177);
        margin-top: 5px;
        border-radius: 10px;
        margin-left: 20px;
}
 .team {
        display: inline-block;
        height: 140px;
        background-color: rgb(39, 121, 177);
        margin-top: 5px;
        border-radius: 10px;
    }
    .teamVS {
        display: inline-block;
        background-color: rgb(209, 63, 63);
        margin-top: 5px;
        height: 140px;
        border-radius: 10px;
    }
    .vs {
         display: inline-block;
        
         width: 20px;
         text-align: center;
    }
    .equipePool {
        display: inline-block;
        vertical-align: top;
        background-color: rgb(206, 206, 205);
        border-radius: 20px;
        padding: 3px;
        margin: 2px;
      
    }
    .equipePool:nth-child(odd) {
        background-color: rgba(226, 226, 224, 0.87);
    }
    
    .equipeItem {
        display: inline-block;
        height: 200px;
        margin: 1px;
        padding: 4px;
        border: thin dashed gray;
        border-radius: 20px;
    }
   
    .equipeFinish {
        display: inline-block;
        height: 200px;
        margin: 1px;
        padding: 4px;
        border: thin dashed gray;
        border-radius: 20px;
        background-color: gray;
    }
    .equipePreFinih {
         display: inline-block;
        background-color: rgb(169, 230, 169);
        height:200px;
        border-radius: 20px;
      
    }
   
    .finish {
      text-align: center;
      margin-top: 5px;
      margin-bottom: 10px;
    }
    .finishLater {
        height: 45px;
        font-size: 14px;
        font-style: italic;
        color: black;
        margin-top: 5px;
        background-color : rgb(230, 195, 80); 
    }
    .WAITING {
        color: rgb(35, 90, 161);
        padding-left: 5px;
    }
    .termine {
        color: rgb(243, 247, 244);
        padding-left: 5px;
    }
</style>
<script>
import equipe from "@/views/tournoi/inProgress/equipeChampionnat.vue"
import equipeQualified from "@/views/tournoi/championnat/equipeQualified.vue"
import tournoi_fct from '@/firebase/tournoi'
import firebase_api from '@/firebase/firebase_api'
import Championnat_DB from "@/firebase/championnat"
export default {
    props: ["refresh","indexPartie", "nbParties", "tournoi", "joueurs", "search", "role","changeFlagJoueur","club","showError"],
    components: {
        equipe,
        equipeQualified
    },
    computed: {
        async completeJoueursForCadrage() {
            
            if (this.partie!=null)
             if (this.partie.type=="CADRAGE") {
                
                var completeJoueurs=[];
                var equipeCadrage=[];
                this.equipes.forEach(equipe=>{
                    equipeCadrage.push(equipe.joueurs.J1.numero);
                    equipeCadrage.push(equipe.contre.J1.numero);
                })
                
                var tournoiDB = firebase_api.api.getDb().collection("club").doc(this.club.id).collection("tournois").doc(this.tournoi.id);
                var indexPartiePrec = this.indexPartie-1;
                var partieDB =  tournoiDB.collection("parties").doc("P"+indexPartiePrec);
                var partieDBDoc = await partieDB.get();
                var partieData = await partieDBDoc.data();
            
                partieData.qualifie.forEach(numero=>{
                    if (equipeCadrage.indexOf(numero)==-1) {
                        var equipe = {
                            joueurs: {
                               J1: { numero: numero},
                               J2: null,
                               J3: null
                            },
                            contre: {
                               J1: { numero: numero},
                               J2: null,
                               J3: null
                            },
                            state:"FINISH",
                            score: {
                                joueurs: 13,
                                contre: 7
                            }
                        }
                        completeJoueurs.push(equipe);
                    }
                })
            }
           return completeJoueurs;
        }
    },
    data() {
        return {
            equipes: [],
            partie: null,
            openJoueurModify: false,
            joueurSelected: null,
            poolCurrent: null,
            currentCLASSTeamPOUL: null,
            currentCLASSPOUL: null,
            pools: [],
            verifJoueurs:[],
            waitingDeverouiller: false
        }
    },
    watch: {
        
        equipes: function(equipes) {
            
            var indexPool = 0;
            var pools= [];
            
            this.equipes.forEach(equipeItem=>{
                indexPool = equipeItem.pool==null ? 0 : equipeItem.pool;
                if (typeof(pools[indexPool])=="undefined")
                    pools[indexPool]= {
                        equipes: [],
                        joueurs: []
                        
                    }
                pools[indexPool].equipes.push(equipeItem);
                pools[indexPool].joueurs.push(equipeItem.joueurs.J1.numero);
                pools[indexPool].joueurs.push(equipeItem.contre.J1.numero);
                       
            })
            
            this.pools = pools;
        
          
        }
    },
    mounted() {
        this.$bind("equipes", firebase_api.api.getDb().collection("club").doc(this.club.id).collection("tournois").doc(this.tournoi.id)
                    .collection("parties").doc("P"+this.indexPartie).collection("equipes"));
        this.$bind("partie", firebase_api.api.getDb().collection("club").doc(this.club.id).collection("tournois").doc(this.tournoi.id)
                    .collection("parties").doc("P"+this.indexPartie));
         
        
    },
    methods: {
          openModalScore(equipe, type) {
          //  console.log(equipe);
         
          var errorOnLine = false;
         
            if (this.isOffline && typeof(this.tournoi.options.choiceWaitingPartie)!="undefined")
                errorOnLine = !this.tournoi.options.choiceWaitingPartie;
           
            if (!errorOnLine)
                this.$emit("openModalScore",equipe, type);
            else {
                alert("Il faut vous connecter sur internet");
            }
        },
        equipeIsLock(equipe) {
            var GG = true;
            if (typeof(this.tournoi.options.championnat)!="undefined")
                if (this.tournoi.options.championnat.type == 'classique')
                    GG = false;

          
            if (GG) {
                if (this.indexPartie>1 && (!this.tournoi.cadrage || this.partie.type=='CADRAGE' || this.partie.type=='BARRAGE')) {
                    return (this.indexPartie!=this.nbParties-1)
                }
                else if (typeof(equipe.lock)=="undefined")
                    return false;
                else
                    return equipe.lock;
            }
            else {
                if (this.partie.type == "ELIMINATOIRE")
                    return false;
                else
                    return this.tournoi.cadrage;
            }
        },
        canDeverouiller(equipe) {
           return true;
           
        },
        showDeverouiller(equipe) {
            var GG = true;
            if (typeof(this.tournoi.options.championnat)!="undefined")
                if (this.tournoi.options.championnat.type == 'classique')
                    GG = false;
            if (equipe.contre.J1.numero==null && GG)
                return false;
            else {
                var bool = equipe.state == 'FINISH'
                if (bool) {

                    return true;
                }
                else
                    return false;
            }
        },
        deverouiller(equipe) {
            
            
            
            
            equipe.score.joueurs = null;
            equipe.score.contre = null;

            var GG = true;
            if (typeof(this.tournoi.options.championnat)!="undefined")
                if (this.tournoi.options.championnat.type == 'classique')
                    GG = false;
            if (GG) {
                this.partie.state="WAITING";
                if (this.indexPartie>=0 && this.indexPartie<3) {
                    Championnat_DB.object.setScorePool(this.club, this.tournoi, this.indexPartie, equipe, ()=>{
                        equipe.state="WAITING";
                        this.partie.state="INPROGRESS";
                        
                    });
                }
                else {
                    Championnat_DB.object.setScore(this.club, this.tournoi, this.indexPartie, equipe, ()=>{
                        equipe.state="WAITING";
                        this.partie.state="INPROGRESS";

                    });
                }
            }
            else {
                this.partie.state = "INPROGRESS";
                 equipe.state = "WAITING";
                 this.$firestoreRefs.equipes.doc(equipe.id).set(equipe).then(
                     ()=>{
                         
                         this.verifStatePartie(this.indexPartie);
                     }
                 );
            }
        },
        selectJoueur(joueurSelected, equipeSelected) {
            
            this.$emit("selectJoueur", joueurSelected, equipeSelected);
        },
        verifStatePartie(indexPartie) {
           var finish = true;
           this.equipes.forEach(equipe=>{
                finish = equipe.state == 'FINISH' && finish;
            })
            
            if (finish) {
                this.$firestoreRefs.partie.update({
                    state : "FINISH"
                })
            }
            else {
                this.partie.state = "INPROGRESS";
                this.$firestoreRefs.partie.update({
                    state : "INPROGRESS"
                })
            }
        },
        getClassPool(indexPool) {
           /* if (equipe.pool==this.poolCurrent) {
                        return this.currentCLASSPOUL;
            }
            else {
                this.currentCLASSPOUL = this.currentCLASSPOUL=='equipePool' ? 'equipePool2' : 'equipePool'; 
                this.poolCurrent=equipe.pool;
                return this.currentCLASSPOUL;
            }*/
            if (this.partie!=null) {
                if (this.partie.type!='CADRAGE' && this.partie.type!='ELIMINATOIRE')
                    return "equipePool";
                else
                    return "";
            }
            else 
                return "";
            
        },
        getClassTeam(equipe) {
            return 'equipeItem';
            
            if (equipe.state == "FINISH") 
                return 'equipeFinish';
            else if (this.isReady(equipe))
                return 'equipePreFinih';
            else {
                return 'equipeItem';
                /*
                if (equipe.pool==this.poolCurrent) {
                    return this.currentCLASSTeamPOUL;
                }
                else {
                    this.currentCLASSTeamPOUL = this.currentCLASSTeamPOUL=='equipeItem' ? 'equipeItem2' : 'equipeItem'; 
                    
                    return this.currentCLASSTeamPOUL;
                }*/
            }
        },
        isReady(equipe) {   
           
            return (equipe.score.contre == this.tournoi.winAt) || (equipe.score.joueurs == this.tournoi.winAt) 
        },
         findName (joueur) {
            return this.joueurs[joueur.numero].pseudo.toUpperCase().indexOf(this.search.toUpperCase()) != -1
        },
        isSearch(equipe) {
            var bool = false;
            if (this.search == "")
                bool = true;
            else if (!isNaN(this.search)) {
                if (equipe.joueurs.J1)
                    bool = parseInt(equipe.joueurs.J1.numero)+1 == parseInt(this.search);
               
                if (!bool) {
                    if (equipe.joueurs.J2)
                    bool = parseInt(equipe.joueurs.J2.numero)+1 == parseInt(this.search)
                }
                
                if (!bool) {
                    if (equipe.joueurs.J3)
                    bool = parseInt(equipe.joueurs.J3.numero)+1 == parseInt(this.search)
                }

                if (!bool) {
                    if (equipe.contre.J1)
                    bool = parseInt(equipe.contre.J1.numero)+1 == parseInt(this.search)
                   
                }
                if (!bool) {
                    if (equipe.contre.J2)
                    bool = parseInt(equipe.contre.J2.numero)+1 == parseInt(this.search)
                    
                }
                 if (!bool) {
                     if (equipe.contre.J3)
                    bool = parseInt(equipe.contre.J3.numero)+1 == parseInt(this.search)
                    
                }
            }
            else {
                var bool = false;
                if (equipe.joueurs.J1)
                bool = this.findName (equipe.joueurs.J1);
                if (!bool)
                    if (equipe.joueurs.J2)
                    bool = this.findName (equipe.joueurs.J2);
                if (!bool)
                if (equipe.joueurs.J3)
                    bool = this.findName (equipe.joueurs.J3);
                if (!bool)
                if (equipe.contre.J1)
                    bool = this.findName (equipe.contre.J1);
                if (!bool)
                if (equipe.contre.J2)
                    bool = this.findName (equipe.contre.J2);
                 if (!bool)
                 if (equipe.contre.J3)
                    bool = this.findName (equipe.contre.J3);
            }
            return bool;
        },
       
        deleteJoueur( joueur, equipe) {
            this.$emit("deleteJoueur")
        },
        changerJoueur( joueur, equipe) {
            this.$emit("changerJoueur", joueur, equipe)
        },
        changeEffect(joueur, equipe) {
           
            this.$emit("changeEffect", joueur, equipe);
        },
        setArrayQualified(tab, indexPartie, numero) {
            if (typeof(tab[indexPartie]) == "undefined") {
                tab[indexPartie] = [];
            }
            
            if(tab[indexPartie].indexOf(numero)==-1)
                tab[indexPartie].push(numero);
          
        },
         eraserScore(equipe) {
            equipe.score['joueurs'] = '';
            equipe.score['contre'] = '';
            this.saveScore(equipe);
            this.partie.state="INPROGRESS";
            //this.$firestoreRefs.equipes.doc(equipe.id).set(equipe);
            //this.verifStatePartie(this.indexPartie)
        },
        saveScore(equipe) {
            this.partie.state="WAITING";
            var flag = true;
            if (equipe.score['joueurs'] == '' || equipe.score['contre']=='')
                flag = false;
            if (equipe.score['joueurs'] == '0' || equipe.score['contre']=='0')
                flag = true;
             if (flag) {
                if (!isNaN(equipe.score['joueurs']))
                    equipe.score['joueurs'] = parseInt(equipe.score['joueurs']);
                if (!isNaN(equipe.score['joueurs']))
                    equipe.score['contre'] = parseInt(equipe.score['contre']);
           
           
                equipe.score['joueurs'] = parseInt(equipe.score['joueurs']);
                equipe.score['contre'] = parseInt(equipe.score['contre']);
                if (equipe.score['joueurs'] >= 0 && equipe.score['contre'] >=0) {
                    equipe.state = "FINISH";
                    if (this.indexPartie>=0 && this.indexPartie<3) {
                        var GG = true;
                        if (typeof(this.tournoi.options.championnat)!="undefined")
                            if (this.tournoi.options.championnat.type == 'classique')
                                GG = false;
                        
                        if (GG)
                            Championnat_DB.object.setScorePool(this.club, this.tournoi, this.indexPartie, equipe, ()=>{});
                        else
                            this.$firestoreRefs.equipes.doc(equipe.id).set(equipe).then(()=>{
                               // TODODODO
                               // il faut vérifier si la partie est terminée ou pas
                               // this.partie.state="INPROGRESS";
                               this.verifStatePartie(this.indexPartie);
                            });
                    }
                    if( this.indexPartie>2) {
                         Championnat_DB.object.setScore(this.club, this.tournoi, this.indexPartie, equipe, ()=>{
                             
                            if (typeof(this.tournoi.cadrage)!="undefined")
                                if (this.tournoi.cadrage)
                                    Championnat_DB.object.eliminatoire(this.club, this.tournoi, this.indexPartie).then(json=>{
                                })
                         })
                    }
                }
            
             }
        },
    }
}
</script>